/**
 * Resize Handles for Selected Section.
 *
 * Renders 8 draggable handle circles (4 corners + 4 midpoints) around the
 * bounding box of the selected section. Each handle has a specific cursor
 * and resize direction.
 */

export type HandlePosition = "nw" | "n" | "ne" | "e" | "se" | "s" | "sw" | "w";

interface ResizeHandlesProps {
  x: number;
  y: number;
  width: number;
  height: number;
  scale: number;
  onHandlePointerDown: (handle: HandlePosition, e: React.PointerEvent) => void;
}

const HANDLE_RADIUS = 4;

const CURSOR_MAP: Record<HandlePosition, string> = {
  nw: "nw-resize",
  n: "n-resize",
  ne: "ne-resize",
  e: "e-resize",
  se: "se-resize",
  s: "s-resize",
  sw: "sw-resize",
  w: "w-resize",
};

function ResizeHandles({
  x,
  y,
  width,
  height,
  scale,
  onHandlePointerDown,
}: ResizeHandlesProps) {
  const r = HANDLE_RADIUS / scale;
  const cx = x + width / 2;
  const cy = y + height / 2;

  const handles: Array<{ pos: HandlePosition; hx: number; hy: number }> = [
    { pos: "nw", hx: x, hy: y },
    { pos: "n", hx: cx, hy: y },
    { pos: "ne", hx: x + width, hy: y },
    { pos: "e", hx: x + width, hy: cy },
    { pos: "se", hx: x + width, hy: y + height },
    { pos: "s", hx: cx, hy: y + height },
    { pos: "sw", hx: x, hy: y + height },
    { pos: "w", hx: x, hy: cy },
  ];

  return (
    <g>
      {handles.map(({ pos, hx, hy }) => (
        <circle
          key={pos}
          cx={hx}
          cy={hy}
          r={r}
          fill="white"
          stroke="#7c3aed"
          strokeWidth={1.5 / scale}
          style={{ cursor: CURSOR_MAP[pos] }}
          onPointerDown={(e) => {
            e.stopPropagation();
            onHandlePointerDown(pos, e);
          }}
        />
      ))}
    </g>
  );
}

export default ResizeHandles;
